export const module = (theme) => ({
    /* Styles applied to the root element. */
    module: {
        position: "relative",
        //border: showGuides('4px solid red'), // FIX ** guides
        margin: "0 !important", // Force reset all
        //padding: '0 !important', // Force reset all
        padding: theme.spacing(4, 4, 4, 4), // FIX **
        "&::after": {
            content: '""',
            clear: "both",
            display: "table",
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(3, 0, 3, 0), // FIX **
        },
    },
    variantFull: {
        padding: theme.spacing(4, 0, 4, 0),
        [theme.breakpoints.down("sm")]: {
            padding: 0,
        },
        "& $container": {
            maxWidth: "100%",
            width: "100%",
            margin: "0 auto",
        },
    },
    variantLeft: {
        [theme.breakpoints.down("md")]: {
            paddingRight: 0,
        },
        "& $container": {},
    },
    variantRight: {
        [theme.breakpoints.down("md")]: {
            paddingLeft: 0,
        },
        "& $container": {},
    },
    variantWrap: {
        padding: theme.spacing(12),
        [theme.breakpoints.down("xs")]: {
            padding: theme.spacing(4),
        },
        "& $container": {},
    },
    container: {
        //border: showGuides('4px solid blue'),  // FIX ** guides
        height: "100%",
    },
    noMargin: { padding: 0 },
    marginBottomOnly: {
        padding: 0,
        marginBottom: `${theme.spacing(3)}px !important`,
        [theme.breakpoints.down("sm")]: {
            //marginBottom: '0 !important',
        },
    },
    hidden: {
        visibility: "hidden",
        opacity: "0",
    },
    visible: {
        visibility: "visible",
        transition: "opacity 200ms ease-out",
        opacity: "1",
    },
});
